<template>
  <b-container id="Vantagens">
    <h3>Mais vantagens</h3>

    <div class="advantages-box">
      <div class="advantages-box__item">
        <div class="advantages-box__item__img">
          <img loading="lazy" width="124" height="104" :src="iconTicket" alt="Ícone sem multa">
        </div>
        <h3>Cancele <br /> sem multas</h3>
        <p>Não acionou o seguro? Cancele quando quiser</p>
      </div>

      <div class="advantages-box__item">
        <div class="advantages-box__item__img">
          <img loading="lazy" width="124" height="104" :src="iconClock" alt="Ícone troca">
        </div>
        <h3>Troca</h3>
        <p>Em caso de troca, um novo aparelho chega rápido na sua casa </p>
      </div>

      <div class="advantages-box__item">
        <div class="advantages-box__item__img">
          <img loading="lazy" width="95" height="104" :src="iconCalendar" alt="Ícone elegibilidade">
        </div>
        <h3>Elegibilidade de <br /> até 24 meses</h3>
        <p>Aparelhos com até 24 meses da data da compra. Inclusive, os adquiridos no exterior</p>
      </div>

      <div class="advantages-box__item">
        <div class="advantages-box__item__img">
          <img loading="lazy" width="124" height="68" :src="iconDevices" alt="Ícone entrega">
        </div>
        <h3>Proteja todos <br /> seus dispositivos</h3>
        <p>Notebook, tablet e smartwatch de uso pessoal ou profissional</p>
      </div>
    </div>

    <Button
      id="btn-cotar-agora-vantagens-portateis"
      label="COTAR AGORA"
      theme="pink"
      @click="scrollTo('home')"
    />
  </b-container>
</template>
<script>
import Button from '@/components/ui/Button'

export default {
  name: 'Vantagens',
  components: {
    Button
  },
  computed: {
    iconTicket () {
      return require(`@/assets/svg/icon-broken-contract-green.svg`)
    },
    iconDevices () {
      return require(`@/assets/svg/icon-devices-green.svg`)
    },
    iconCalendar () {
      return require(`@/assets/svg/icone-data.svg`)
    },
    iconClock () {
      return require(`@/assets/svg/icone-tempo.svg`)
    }
  },
  methods: {
    scrollTo (target) {
      return document.getElementById(target).scrollIntoView()
    }
  }
}
</script>

<style lang="scss" scoped>
#Vantagens {
  text-align: center;

  h3 {
    color: #324B68;
    font-family: Oscine, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 62px;
    text-align: center;
  }

  .advantages-box {
    display: grid;
    grid-template-columns: 1fr;
    gap: 54px 54px;
    margin: 64px 0;

    @media only screen and (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (min-width: 960px) {
      grid-template-columns: repeat(4, 1fr);
    }

    &__item {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      &__img {
        align-items: center;
        display: flex;
        height: 104px;
        justify-content: center;
        width: 100%;
      }

      h3 {
        color: #324B68;
        font-family: Oscine, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 30px;
        text-align: center;
        margin: 32px 0 24px;
      }

      p {
        font-family: Rubik, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #4E5356;
        width: 100%;
        max-width: 224px;
      }
    }
  }

  button {
    margin: 0 auto 104px;
    width: 320px;
  }
}
</style>
